import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import styled from "@emotion/styled";
import React, { FC } from "react";

interface IconAndAmountProps {
  Icon?: JSX.Element | string;
  img?: string;
  amount: string | number;
  fontSize?: string;
}

const IconAndAmount: FC<IconAndAmountProps> = props => {
  return (
    <Container>
      <IconContainer fontSize={props.fontSize}>{props.Icon}</IconContainer>
      <TextSimple color="gray" size="label" font="gotham" weight="bold">
        {props.amount}
      </TextSimple>
    </Container>
  );
};
export const ImgAndAmount: FC<IconAndAmountProps> = props => {
  return (
    <Container>
      <img src={props.img} />
      <TextSimple color="gray" size="label" font="gotham" weight="bold">
        {props.amount}
      </TextSimple>
    </Container>
  );
};

export default IconAndAmount;

const Container = styled.div`
  display: flex;
  gap: 2px;
  flex-direction: row;
  align-items: center;
  img {
    width: 25px;
    height: 25px;
    object-fit: contain;
  }
`;

const IconContainer = styled.div<{ fontSize?: string }>`
  width: ${({ fontSize }) => fontSize || "1.5625rem"};
  height: ${({ fontSize }) => fontSize || "1.5625rem"};
  font-weight: bold;
  svg {
    width: ${({ fontSize }) => fontSize || "1.5625rem"};
    height: ${({ fontSize }) => fontSize || "1.5625rem"};
    color: var(--text-gray);
    fill: var(--text-gray);
  }
`;
